jQuery(document).ready(function() {
	jQuery('.expertchat .textContainer, .expertchat .imageContainer').click(function(evt) {
		$this = jQuery(this);
		jQuery('.expertChatJsInclude a img', $this.closest('.expertchat')).click();
	});
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/expertchat.js
// module id = 115
// module chunks = 0